import { Tag } from "bbcode-to-react";
import * as React from "react";
import { withTranslation } from "react-i18next";
class Spoiler extends React.Component {
    constructor(props) {
        super(props);
        this.state = { display: false };
    }
    render() {
        const { t } = this.props;
        return (React.createElement("div", { className: "bbcode-spoiler-tag" },
            React.createElement("a", { onClick: this.toggle }, t(this.props.label ?? "More")),
            this.state.display ? (React.createElement("div", { className: "bbcode-spoiler-content" }, this.props.content)) : null));
    }
    toggle = () => {
        this.setState({ display: !this.state.display });
    };
}
const SpoilerTrans = withTranslation(["common"])(Spoiler);
class SpoilerTag extends Tag {
    toHTML() {
        return [this.getContent()];
    }
    toReact() {
        return (React.createElement(SpoilerTrans, { content: this.getComponents(), label: this.params.label }));
    }
}
export default SpoilerTag;
